// @flow
import React from "react";
import styled from "styled-components";
import { News } from "./Item";
import { fontSize } from "../common/styled-mixins";
import { Link as _Link } from "../common/Link";
import { GiftIcon } from "../AccountType/Icons";
import InviteImg from "../Tournaments/images/invite@3x.png";
import Gettext from "../common/Gettext";
import Money from "../Money";
import Timer, {
  getActive,
  getCompleted,
  getDuration
} from "../Tournaments/Timer";
import { ModalConsumer } from "../common/ModalProvider";
import { JoinPopup } from "../Tournaments/Popups";
import bgImg from "../../images/demo-tournament-bg.png";
import { gaReducer } from "../GA";

const Congratulation = styled(News)`
  position: relative;
`;

const TitleIcon = styled.div`
  margin-right: 10px;
  flex: 0 0 auto;
  color: #bebebe;
`;

const Title = styled.div`
  font-size: ${fontSize(12)};
  margin-bottom: 17px;
  color: #919191;
  text-transform: uppercase;
  font-weight: 700;
  display: flex;
  align-items: center;
`;

const Text = styled.div`
  font-size: ${fontSize(14)};
  color: #343434;
  font-weight: 700;
  margin-bottom: 16px;
  line-height: 1.3;
`;

const Link = styled(_Link)`
  color: #0085eb;
  font-size: ${fontSize(12)};
`;

const TournamentBlock = styled.div`
  margin-bottom: 14px;
  padding: 21px 10px;
  background-color: #000;
  margin-right: -17px;
  margin-left: -17px;
  text-align: center;
  background-image: url(${bgImg});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
`;
const TournamentText = styled.div`
  margin-bottom: 7px;
  font-size: ${fontSize(14)};
  font-weight: 700;
  color: #fff;
  position: relative;
`;
const TournamentPrize = styled.div`
  font-size: ${fontSize(12)};
  font-weight: 700;
  color: #ffcc00;
  position: relative;
`;
const StartLabel = styled.span`
  color: #919191;
  font-size: ${fontSize(12)};
  margin-bottom: 5px;
`;
const StartTime = styled.span`
  color: #343434;
  font-weight: 700;
  font-size: ${fontSize(14)};
`;

const Button = styled.div`
  width: 100%;
  background-color: #0085eb;
  color: #fff;
  font-size: ${fontSize(12)};
  padding: 11px;
  border-radius: 19px;
  margin-bottom: 14px;
  text-align: center;
  text-transform: uppercase;
  font-weight: 900;
  cursor: pointer;
  :hover {
    background-color: #0468b5;
  }
`;
const Links = styled.div`
  display: flex;
  justify-content: space-between;
  text-transform: lowercase;
`;
const TournamentStart = styled.div`
  margin-bottom: 16px;
  text-align: center;
  color: #919191;
`;

const Sticker = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 42px;
  height: 42px;
`;

const ItemCongratulations = ({ tournament }) => {
  if (tournament == null) {
    return null;
  }

  return (
    <Congratulation>
      <Sticker>
        <img src={InviteImg} alt="" />
      </Sticker>
      <Title>
        <TitleIcon>
          <GiftIcon />
        </TitleIcon>
        <Gettext>Congratulations</Gettext>
      </Title>
      <Text>
        <Gettext>
          You have enough DEMO money to purchase a tournament invitation!
        </Gettext>
      </Text>
      <TournamentBlock>
        <TournamentText>{tournament.title}</TournamentText>
        <TournamentPrize>
          <Gettext>Prize fund</Gettext>: <Money>{tournament.prize_fund}</Money>
        </TournamentPrize>
      </TournamentBlock>
      <TournamentStart>
        <Timer
          days={getDuration(tournament, "days")}
          hours={getDuration(tournament, "hours")}
          minutes={getDuration(tournament, "minutes")}
          seconds={getDuration(tournament, "seconds")}
          active={getActive(tournament)}
          isCompleted={getCompleted(tournament)}
          labelOnTop={true}
          flexDirection="column"
          alignItems="center"
          noIcon
          TimeStyle={StartTime}
          TextStyle={StartLabel}
        />
      </TournamentStart>

      <ModalConsumer>
        {({ showModal }) => (
          <Button
            onClick={() => {
              gaReducer("BELL_GO_TO_TOURNAMENT", { type: "join" });
              showModal(JoinPopup, tournament);
            }}
          >
            <Gettext>
              Buy for {<Money>{tournament.participation_price}</Money>} demo
              money
            </Gettext>
          </Button>
        )}
      </ModalConsumer>
      <Links>
        <Link to="/news/doubleup" target="_blank">
          <Gettext>Details</Gettext>
        </Link>
        <Link to="/tournaments">
          <Gettext>Other tournaments</Gettext>
        </Link>
      </Links>
    </Congratulation>
  );
};

export default ItemCongratulations;



// WEBPACK FOOTER //
// ./src/components/Bell/ItemCongratulations.js